import React from 'react';
import { RadioIndicator } from '@components/radio-indicator';
import classNames from 'classnames';

import { InputCardProps, VARIANT_L } from './input-card.type';

export const InputCard = ({ variant, isChecked, isDisabled, children, handleClick }: InputCardProps) => (
  <button
    className='w-full'
    type='button'
    role='radio'
    aria-checked={isChecked}
    disabled={isDisabled}
    onClick={handleClick}>
    <div
      className={classNames('flex w-full rounded-md bg-surface-primary', {
        'py-3 px-4 shadow-md': variant !== VARIANT_L,
        'p-6 border border-extra-soft hover:border-hard focus:border-hard items-start': variant === VARIANT_L,
        'opacity-50': isDisabled,
        'opacity-100': !isDisabled,
      })}>
      <RadioIndicator isChecked={isChecked} className='mr-3' />
      {children}
    </div>
  </button>
);
